/* eslint-disable max-len */
import React from 'react';

export const CartSpot = (): React.ReactElement => (
  <svg fill="none" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
    <circle cx="28.3024" cy="28.0558" fill="#F7F5F0" r="27.6784" />
    <path
      clipRule="evenodd"
      d="M28.457 38.5595c0-1.7148 1.4133-3.1244 3.1326-3.1244 1.7192 0 3.1325 1.4096 3.1325 3.1244s-1.4133 3.1245-3.1325 3.1245c-1.7193 0-3.1326-1.4097-3.1326-3.1245Zm4.3856-.0001c0-.7018-.5494-1.2498-1.253-1.2498-.7036 0-1.253.548-1.253 1.2498s.5494 1.2498 1.253 1.2498c.7036 0 1.253-.548 1.253-1.2498Zm4.3854.0001c0-1.7148 1.4133-3.1244 3.1325-3.1244 1.7193 0 3.1326 1.4096 3.1326 3.1244s-1.4133 3.1245-3.1326 3.1245c-1.7192 0-3.1325-1.4097-3.1325-3.1245Zm4.3856-.0001c0-.7018-.5495-1.2498-1.253-1.2498-.7036 0-1.2531.548-1.2531 1.2498s.5495 1.2498 1.2531 1.2498c.7035 0 1.253-.548 1.253-1.2498Z"
      fill="#25694F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M20.9388 16.0635c-.5188 0-.9398.4199-.9398.9374 0 .5175.421.9373.9398.9373h2.9955l3.2302 15.2025c.1273.5724.5042 1.0484.9789 1.0447H43.806c.4968.0073.9532-.4418.9532-.9373s-.4564-.9447-.9532-.9374H28.9071l-.4013-1.8746h16.5535c.4209-.0037.8186-.3222.9103-.7324l2.1928-9.3734c.1224-.5443-.3512-1.1387-.9104-1.1423H26.127l-.5091-2.3825c-.0893-.4161-.4931-.742-.9202-.742h-3.7589Zm5.5797 4.9992h4.8945l.4699 2.812h-4.7674l-.597-2.812Zm12.7258 0h-5.9126l.4699 2.812h4.9728l.4699-2.812Zm1.9186 0h4.9043l-.6559 2.812h-4.7182l.4698-2.812Zm-8.9664 4.6868h-4.6794l.5974 2.812h4.5518l-.4698-2.812Zm1.9183 0h4.3464l-.4699 2.812h-3.4066l-.4699-2.812Zm10.856 0h-4.591l-.4698 2.812h4.405l.6558-2.812Z"
      fill="#38AF88"
      fillRule="evenodd"
    />
    <path
      d="M22.9957 31.2293H10.709m10.6485-6.1434H5.99902m18.01028 12H14.999"
      stroke="#69D5BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.63824"
    />
  </svg>
);
